import { scrollToSection } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#081B40]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-20 grid md:grid-cols-[1.5fr_1fr_1fr] gap-12">
        <div>
          <img src="/edvio-logo-wide.png" alt="Edvio Language Institute" className="h-20 w-auto" data-testid="footer-logo" />
          <p className="mt-4 max-w-sm text-sm text-[#A3A3A3] leading-relaxed">
            Mangalore's boutique language institute. German, French and Korean — taught in small batches, measured by global certifications.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#A3A3A3] mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {[["Courses", "#courses", "footer-link-courses"], ["Method", "#method", "footer-link-method"], ["Stories", "#stories", "footer-link-stories"], ["Enquire", "#contact", "footer-link-contact"]].map(([label, href, id]) => (
              <button key={id} onClick={() => scrollToSection(href)} className="text-left text-sm text-[#F4F4F0]/80 hover:text-[#C44900] transition-colors w-fit" data-testid={id}>
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <p className="text-sm text-[#F4F4F0]/80 leading-relaxed">
            Marian Corniche Apartments,<br />
            Sulthan Bathery Rd, Boloor,<br />
            Ashok Nagar, Mangaluru – 575006
          </p>
          <a href="tel:9886673234" className="mt-4 inline-block text-sm text-[#C44900] hover:text-[#e05600] transition-colors" data-testid="footer-phone-link">
            98866 73234
          </a>
        </div>
      </div>
      <div className="overflow-hidden select-none" aria-hidden="true">
        <p className="font-display text-stroke text-[clamp(6rem,19vw,17rem)] leading-[0.8] text-center uppercase tracking-tight translate-y-4">Edvio</p>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#A3A3A3]">
          <p>© {new Date().getFullYear()} Edvio Language Institute. All rights reserved.</p>
          <p>German · French · Korean</p>
        </div>
      </div>
    </footer>
  );
}
